// extracted by mini-css-extract-plugin
export default {"button":"primary-wide__button___woGU1 primary__button___frFdc base__button___zT0JW"};